import React, {FC} from 'react';
import { inputProps as InputProps } from '../../types/types';

interface TextInputFieldProps extends InputProps {
    value: string,
    placeholder: string,
    typeOverride?: string
}

const TextInputField: FC<TextInputFieldProps> = ({
    value,
    placeholder,
    label,
    labelText,
    onChange,
    required,
    redHighlight,
    additionalClassNames,
    additionalNote,
    useLabelTextAsHtml,
    typeOverride, // For if there's no other change in HTML
    // refList,
    // refIndexByLabel
}) => {

    return (
        <div
            className={
                "mb-3 w-full " + (additionalClassNames ?? "")
                + (redHighlight ? " required-highlight" : "").replace("  ", " ")
            }
            
        >
            <label htmlFor={label}
                    className="form-label inline-block mb-2 text-gray-700">
                {labelText}
                {required &&
                    <span className="text-red-500 font-bold text-2xl">*</span>
                }
            </label>
            <input
                id={label}
                name={label}
                type={typeOverride ?? "text"}
                className="
                    form-control block w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    m-0 lg:mr-8
                    focus:shadow-none
                    focus:text-gray-700 focus:bg-white focus:border-amber-400 focus:outline-none
                "
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                // ref={(ref) => {
                //     if (refList && refList.current) {
                //         const index = refIndexByLabel!(label);
                //         if (index) {
                //             refList.current[index] = ref;
                //         }
                //     }
                // }}
            />
            {additionalNote !== undefined && <p>{additionalNote}</p>}
        </div>
    );
};

export default TextInputField;